import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: '.element-listing',
  templateUrl: './element-listing.component.html',
  styleUrls: ['./element-listing.component.scss']
})
export class ElementListingComponent implements OnInit {
  @Input() chooseMultiple: boolean;
  @Input() elementType: string;
  @Output() elementSelection = new EventEmitter<any>();
  @Output() closePopupEmit = new EventEmitter<any>();
  elementIdList = [];
  story_Id: number;
  constructor() {
  }
  ngOnInit() {
  }
  elementsSelected(id) {
    this.elementSelection.emit(this.elementIdList);
  }
  closePopup() {
    this.closePopupEmit.emit(null);
  }
  elementSelected(ev) {
    if (ev.type === 'multiple') {
      this.elementIdList = ev.id;
    } else if (ev.type === 'single') {
      this.elementIdList = [ev.id];
      this.elementSelection.emit(ev.id);
    }
  }
}
